export default __webpack_public_path__ + "static/media/Phone.43bc1960.png";